import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "alm-react-components";
import moment from "moment-timezone";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  ActionType,
  APPROUTES,
  constants,
  DateFormat,
  Tag,
} from "../../../assets/constants/constants";
import { AppContext } from "../../../context/AppProvider";
import { QuarterObjType } from "../../../interface";
import getLocalizedContent from "../../../lib/getLocalizedMetaData";
import {
  badgeUrl,
  createCurrentQuarterDetail,
  isEnrollmentDateAvailable,
  weekCount,
  weekCountWithOutDoNotShowProgram,
} from "../../../lib/utils";
import { apis } from "../../../services/alm";
import { CardBox } from "../../common/CardBox";
import { PopOverTitle } from "../../common/PopOverTitle";
import FundamentalProgram from "../../common/FundamentalProgram";
import { DisabledCardPopOver } from "../../common/DisabledCardPopOver";

const UpcommingProgram = ({ isPrevQuarterEnrolledProgram }: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state, dispatch } = useContext(AppContext);
  const [fullCardProgressPercent, setFullCardProgressPercent] =
    useState<number>(0);

  const [currentQuarter, setCurrentQuarter] = useState<QuarterObjType>();
  const [isEnrollmentOpen, setIsEnrollmentOpen] = useState(false);
  const [quaterWiseData, setQuaterWiseData] = useState<any>({
    data: [],
    included: [],
    completed: [],
  });
  const [enrolledProgram, setEnrolledProgram] = useState<any>({
    data: [],
    included: [],
  });
  useEffect(() => {
    if (state.user && state?.quarterDeatil?.currentQuarter) {
      learningProgram();
    }
  }, [state?.quarterDeatil?.currentQuarter]);

  const learningProgram = async () => {
    try {
      const quarterDetail = createCurrentQuarterDetail(
        state.quarterDeatil.currentQuarter,
        state.quarterDeatil.nextQuarter
      );
      createQuaterData(quarterDetail.showQuaterProgramFor);
      setCurrentQuarter(quarterDetail);
      setIsEnrollmentOpen(quarterDetail.showEnrollment);
    } catch (error) {
      console.log(error);
    }
  };
  const createQuaterData = async (quarterDetail: any) => {
    const quarter = `${quarterDetail.quarter}-${quarterDetail.year}`;
    const response: any = await apis.getLearningProgram(quarter);
    try {
      if (response) {
        const enrolledData = response?.data.filter((item: any) => {
          return item.relationships.enrollment;
        });

        const enrolledCompletedId = enrolledData?.map((item: any) => {
          return item?.relationships?.enrollment?.data?.id;
        });
        const tags = response?.included
          ?.filter((res: any) => {
            return enrolledCompletedId.includes(res?.id);
          })
          ?.map((res: any) => res?.attributes?.state == constants.COMPLETED);

        const completedData = enrolledData?.filter((_: any, i: any) => tags[i]);
        /**  filter out the quater listing program 
        // sll corporate leaner have the default program listing 
        // Non sll corporate leaner have all quater program
        */ 
        const quaterWiseDataUnenrolled = response?.data?.filter((item: any) => {
          return !item.relationships.enrollment;
        }).filter((data:any)=>{
          return  state?.user?.sllCorporateAccount  === 1  ? data?.attributes?.tags.includes(Tag.defaultProgram) : true
        });
        const enrolledNotCompleted: any = enrolledData?.filter(
          (_: any, i: any) => !tags[i]
        );

        setQuaterWiseData({
          data: [...quaterWiseDataUnenrolled, ...completedData],
          included: response?.included,
          completed: completedData,
        });

        if (enrolledNotCompleted) {
          const enrolledProgramData = {
            data: enrolledNotCompleted,
            included: response?.included,
          };
        
          setEnrolledProgram(enrolledProgramData);
          dispatch({
            type: ActionType.SET_ENROLLED_PROGRAM,
            payload: enrolledProgramData?.data?.length ? true: false,
          });
          const enrollmentId = enrolledNotCompleted[0]?.relationships?.enrollment?.data?.id;
          const progressDetails = response?.included?.find( (ele: any) => ele?.id === enrollmentId);
          
          setFullCardProgressPercent(
            progressDetails?.attributes?.progressPercent || 0
          );
        }
      }
    } catch (error: any) {
      console.log("error---->", error);
    }
  };

  const onHanleEnrollment = (id: number) => {
    if(!isEnrollmentOpen) {
      dispatch({type:ActionType.ALERT_BOX,payload:{
                visible:true,
                message:t('AlertDialog.disablePCardMsg')
              }})
      return
    }
    const completedIds = quaterWiseData?.completed?.map((res: any) => res.id);
    let programCountEachQuarter:any=[];
    if(enrolledProgram?.data[0]){
      programCountEachQuarter=[...quaterWiseData?.data,...enrolledProgram?.data]
    }else{
      programCountEachQuarter=quaterWiseData?.data
    }
    if (completedIds.includes(id)) {
      navigate(`${APPROUTES.program}/${id}`);
    } else if(isEnrollmentOpen){
      navigate(`${APPROUTES.programOverview}?programId=${id}`, {
        state: {
          enrolled: enrolledProgram?.data[0]?.relationships?.enrollment?.data
            ?.id
            ? enrolledProgram?.data[0]?.relationships?.enrollment?.data?.id
            : false,
          enrolledName: getLocalizedContent(
            enrolledProgram?.data[0]?.attributes?.localizedMetadata
          ).name,
          year: `${currentQuarter?.quarter}-${currentQuarter?.year}`,
          programCountEachQuarter:programCountEachQuarter
        },
      });
      dispatch({
        type: ActionType.SET_DISABLE,
        payload: false,
      });
    }
  };

  return (
    <>
      {((isPrevQuarterEnrolledProgram && !isEnrollmentOpen) ||
        !enrolledProgram?.data?.length) && <FundamentalProgram />}
      {(enrolledProgram?.data?.length > 0 || quaterWiseData?.data?.length > 0) && (
        <div className="w-[100%] mx-auto xl:px-32 lg:px-8 md:px-8 px-5 py-6 md:py-14">
          <div className="flex flex-wrap justify-between md:flex-nowrap">
            <div className="min-w-0 flex-1">
              <h1 className="scroll-m-20 tracking-tight leading-7 text-2xl lg:text-3xl xl:text-4xl font-barlowLight font-light">
                <span
                  className={`font-medium font-barlowMedium ${isEnrollmentOpen ? "text-primary" : ""
                    } `}
                >
                  {currentQuarter?.quarter}{" "}
                </span>{" "}
                <span dangerouslySetInnerHTML={{ __html: t("Program.liveProgram") }} />
              </h1>
              {isEnrollmentOpen && !enrolledProgram?.data?.length &&(
                <p className="[&:not(:first-child)]:mt-6 leading-normal">
                  <span className="text-primary" dangerouslySetInnerHTML={{ __html: t("Program.quarterEnrollmentOpenMsgHighLight") }} />
                  {" "}
                  <span dangerouslySetInnerHTML={{ __html: t("Program.quarterEnrollmentOpenMsg") }} />
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="ms-4 text-2xl font-light w-[18px] h-[18px] text-primary"
                  />
                </p>
              )}
              <div className="[&:not(:first-child)]:mt-6 leading-normal w-full text-editor-dynamic-class">
                {isEnrollmentOpen ?
                  <>{
                    !enrolledProgram?.data?.length&&(
                      <>
                      <span dangerouslySetInnerHTML={{ __html: t('MyStance.enrollmentOnHeading') }}></span>
                      <span dangerouslySetInnerHTML={{ __html: t('MyStance.enrollmentOnMessage') }} ></span>
                      </>
                    )
                  }
                     </> :
                  <><span dangerouslySetInnerHTML={{ __html: t("MyStance.heading") }}></span>
                    <span dangerouslySetInnerHTML={{ __html: t("MyStance.enrollmentNotification") }}></span></>}
              </div>
            </div>
            <div className="flex lg:ml-4 md:pb-6 lg:pb-12">
              <Button
                onClick={() => navigate("/home/quater-list")}
                variant="secondary"
                className="text-base font-normal px-6 py-1 h-9 dark:bg-fillMidGrayCard"
              >
                <span dangerouslySetInnerHTML={{ __html: t("Program.seeAll") }} />
              </Button>
            </div>
          </div>
          {enrolledProgram && enrolledProgram?.data?.length > 0 && (
            <CardBox
              cardInfo={{
                bannerUrl: enrolledProgram?.data[0]?.attributes?.bannerUrl,
                id: enrolledProgram?.data[0]?.id,
                name: getLocalizedContent(
                  enrolledProgram?.data[0]?.attributes?.localizedMetadata
                ).name,
                description: getLocalizedContent(
                  enrolledProgram?.data[0]?.attributes?.localizedMetadata
                ).description,
                relationshipInstancesId:
                  enrolledProgram.data[0]?.relationships?.instances?.data[0]
                    ?.id,
                quarterStartDate: currentQuarter?.start,
                progress: fullCardProgressPercent,
                fullCardIncluded: enrolledProgram?.included,
                weeks: weekCount(enrolledProgram),
              }}
              learningProgramData={enrolledProgram?.included}
              headerHide={true}
            />
          )}
          <div className="mt-10 max-sm:flex-wrap max-sm:flex-col sm:flex-wrap sm:flex-col md:flex-wrap lg:flex-nowrap gap-5 items-stretch max-md:ml-0 -ml-5 flex lg:flex-row lg:gap-0 md:gap-0 md:gap-y-5 md:flex md:flex-row">
            {quaterWiseData?.data
              ?.sort((a: any, b: any) =>
                b?.attributes?.localizedMetadata[0]?.name.localeCompare(
                  a?.attributes?.localizedMetadata[0]?.name,
                  "es",
                  { sensitivity: "base" }
                )
              )
              .slice(0, 2)
              .map((item: any, index: number) => {
                const content = getLocalizedContent(
                  item?.attributes?.localizedMetadata
                );

                return (
                  <div
                    key={`quater-list-${index}`}
                    className="landscape:2xl:basis-1/2 landscape:xl:basis-1/2 landscape:lg:basis-1/2 landscape:md:basis-1/1 portrait:md:basis-1/1 md:pl-5 w-full"
                    onClick={() => onHanleEnrollment(item?.id)}
                  >
                    <DisabledCardPopOver
                                    text={t('AlertDialog.disablePCardMsg')}
                                    component={
                    <Card
                      className={`w-full sm:w-full cursor-pointer h-auto p-0 border-cardBorder common-card-bg flex overflow-hidden max-md:flex-col`}
                    >
                      <CardHeader className="flex flex-col p-0 relative space-y-0 h-[211px] overflow-hidden w-full">
                        <div className=" flex items-center text-xs ml-4 mt-4 border  p-[3px] absolute top-0 left-0 rounded-md text-white px-1.5 bg-[#181818]">
                          <p
                            className={`w-[8px] h-[8px] ${isEnrollmentDateAvailable(currentQuarter?.start)
                                ? "rounded-full bg-red-500 circle mt-2 ml-2"
                                : "rounded-lg bg-red-500"
                              }`}
                          ></p>
                          <p className="mx-2 uppercase text-red-50">
                            <span dangerouslySetInnerHTML={{ __html: t("Program.liveProgram") }} />
                          </p>
                        </div>
                        {quaterWiseData?.completed?.map(
                          (res: any, index: number) => {
                            return res?.id === item.id ? (
                              <>
                                <div
                                  key={index + "_" + res?.id}
                                  className="absolute top-4 right-0 flex gap-2 items-center text-xs me-4 mt-4 border bg-[#181818] p-[3px] rounded-md text-white px-1.5"
                                >
                                  <p
                                    className={`${isEnrollmentDateAvailable(
                                      currentQuarter?.start
                                    )
                                        ? "mx-3"
                                        : ""
                                      } uppercase text-red-50`}
                                  >
                                    <span dangerouslySetInnerHTML={{ __html: t("Common.completed") }} />
                                  </p>
                                </div>
                              </>
                            ) : (
                              ""
                            );
                          }
                        )}
                        <img
                          src={item?.attributes?.imageUrl}
                          alt="No Image"
                          className="w-full h-[inherit] object-cover object-center bg-center lg:col-span-full rounded-xl rounded-tr-none rounded-b-none bg-fillLightGrayCard"
                        />
                      </CardHeader>
                      <CardContent className="p-6 pt-0 px-6 mt-6 xl:min-h-36 lg:min-h-full w-[inherit]">
                        <div className="flex flex-row justify-between">
                          <CardTitle className="text-wrap lg:text-xl xl:text-2xl font-barlowMedium">
                            {content.name}
                          </CardTitle>
                          <PopOverTitle name={content.name} />
                          <img
                            src={badgeUrl(
                              item?.relationships?.instances?.data[0]?.id,
                              quaterWiseData?.included
                            )}
                            alt="No image"
                            className={`${isEnrollmentOpen ? "yellow" : ""
                              } w-[85px] h-[59px] basis-[content]`}
                          />
                        </div>
                        <div className="flex mt-5 text-base font-opensansLight">
                          <span className="capitalize">
                            {moment(currentQuarter?.start).format(DateFormat)}{" "}
                          </span>
                          <div className="flex-col">
                            <div className="ms-2">
                              |{weekCountWithOutDoNotShowProgram(item)}{" "}
                              <span dangerouslySetInnerHTML={{ __html: weekCountWithOutDoNotShowProgram(item) > 1 ? t("Common.weeks") : t("Common.week") }} />
                            </div>
                          </div>
                        </div>
                      </CardContent>
                    </Card>}
                     show={!isEnrollmentOpen}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      )}
      {isEnrollmentOpen && enrolledProgram?.data?.length > 0 && (
        <FundamentalProgram />
      )}
    </>
  );
};

export default UpcommingProgram;
